import styled from "styled-components";

export const HeaderCall2Action = styled.div`
  flex: 4;

  @media (max-width: 1040px) {
    flex-basis: 100%;
  }

  h1 {
    color: #fff;
    font-size: 58px;
    font-weight: 300;
    margin: 2rem auto;

    span {
      color: ${({ theme }) => theme.colors.primaryLight};
    }
  }

  button {
    font-size: 22px;
  }
`;

export const HeaderCompanyHours = styled.div`
  flex: 2;
  background-color: rgba(59, 175, 191, 0.45);
  padding: 2rem 3rem;
  margin: 2rem auto;

  @media (max-width: 1040px) {
    flex-basis: 100%;
    margin-top: 3rem;
  }

  h3 {
    font-size: 32px;
    font-weight: 300;
    text-align: center;
    color: #fff;
  }

  hr {
    border: solid 4px ${({ theme }) => theme.colors.primaryDark};
    margin: 1rem auto 1.5rem;
  }
`;

export const Paragraph = styled.p`
  font-size: 24px;
  color: #fff;
  line-height: 3.5rem;
  margin: 10px 0 40px;

  & > span:nth-of-type(1) {
    margin-top: 2rem;
  }

  & > span {
    display: flex;
    justify-content: space-between;

    & > span {
      margin: .5rem 0;

      @media(max-width: 1040px) {
        flex: 1;
      }

      &:last-child {
        @media(max-width: 1000px) {
          text-align: end;
        }
      }
    }
  }
`;
